/**
 * The live open-table set, persisted as { gameID: gameType }.
 *
 * Written by ViewManagerContext (from state.tables, so it self-prunes as
 * tables close; a transiently-empty set never overwrites it) and read by:
 *   • the refresh-restore watcher, to re-subscribe the set at boot, and
 *   • useActiveTables, to tell "closed" apart from "not restored YET" while
 *     pruning its order tracker mid-restore.
 * Cleared on logout (utils/auth.ts clearAuth).
 */
export const LAST_OPEN_TABLES_KEY = 'lastOpenTables';

/**
 * How long a refresh waits for the remembered tables to come back: the
 * refresh-restore watcher's ceiling, and the window in which useActiveTables
 * treats a remembered-but-not-yet-loaded table as "on its way", not "closed".
 */
export const RESTORE_MAX_WAIT_MS = 15000;

export const readLastOpenTables = (): Record<string, string> => {
  try {
    const raw = JSON.parse(localStorage.getItem(LAST_OPEN_TABLES_KEY) || '{}');
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
    const out: Record<string, string> = {};
    Object.entries(raw).forEach(([gid, game]) => {
      if (gid && typeof game === 'string' && game) out[gid] = game;
    });
    return out;
  } catch {
    return {};
  }
};
